import { useInvoicesApi } from "@/Hooks/useInvoicesApi";
import type { InvoiceStatsResponse } from "@freightsimple/generated-dashboard-openapi-client/models/InvoiceStatsResponse";
import { ResponseError } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import useInterval from "@/Hooks/useInterval";
import { useOnce } from "@/Hooks/useOnce";
import { useState } from "react";

export function useInvoicesStats() {
  const invoicesApi = useInvoicesApi();
  const [invoicesStats, setInvoicesStats] = useState<
    InvoiceStatsResponse | undefined
  >();

  async function refresh() {
    try {
      const response = await invoicesApi.getInvoiceStats();
      setInvoicesStats(response);
    } catch (error) {
      if (error instanceof ResponseError) {
        console.error("Failed to fetch invoice stats", {
          status: error.response.status,
          statusText: error.response.statusText,
        });
      } else {
        console.error("Unexpected error fetching invoice stats", error);
      }
    }
  }

  // Refresh every 3 minutes
  useInterval(
    function () {
      refresh();
    },
    3 * 60 * 1000,
  );

  useOnce(async () => {
    refresh();
  });

  return { invoicesStats, refresh };
}
